import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { LeadCardWizard } from './wizard/LeadCardWizard'
import { UserLayout } from 'components/layout/UserLayout'
import { useFetchLeadCard } from 'hooks/lead-card/fetch-lead-card'
import { Loading, useGetBusinessID, useGetParam } from '@marketing-milk/frontend'
import { FullPageHeader } from 'components/layout/FullPageLayout/Header/FullPageHeader'
import { FullPageContent } from 'components/layout/FullPageLayout/Content/FullPageContent'

export function EditLeadCard() {
  const history = useHistory()
  const businessID = useGetBusinessID()
  const leadCardID = useGetParam('leadCardID')
  const leadCard = useFetchLeadCard(Number(businessID), Number(leadCardID))

  useEffect(() => {
    if (leadCard) {
      history.push(`/${businessID}/lead-cards`)
    }
  }, [businessID])

  return (
    <UserLayout>
      <FullPageHeader
        breadcrumbs={[
          { title: 'Lead Cards', route: `/${businessID}/lead-cards` },
          { title: leadCard?.formName || '...loading' },
        ]}
      ></FullPageHeader>

      <FullPageContent className="flex flex-col sm:p-4">
        {leadCard ? <LeadCardWizard defaultLeadCard={leadCard} /> : <Loading />}
      </FullPageContent>
    </UserLayout>
  )
}
